import { TenantLoginInfoDto } from './service-proxies';

declare module './service-proxies' {
    interface TenantLoginInfoDto {
        HasLogo(): boolean;
        HasLogoMinimal(): boolean;
        HasDarkLogo(): boolean;
        HasLightLogo(): boolean;
    }
}

TenantLoginInfoDto.prototype.HasLogo = function (): boolean {
    return (this.logoId != null && this.logoFileType != null);
}

TenantLoginInfoDto.prototype.HasLogoMinimal = function (): boolean {
    return (this.logoMinimalId != null && this.logoMinimalFileType != null);
}

TenantLoginInfoDto.prototype.HasDarkLogo = function (): boolean {
    return this.logoId != null && this.logoFileType != null;
}

TenantLoginInfoDto.prototype.HasLightLogo = function (): boolean {
    return this.logoId != null && this.logoFileType != null;
}

